import script from "./AbitFormBuilder.vue?vue&type=script&setup=true&lang=ts"
export * from "./AbitFormBuilder.vue?vue&type=script&setup=true&lang=ts"

import "./AbitFormBuilder.vue?vue&type=style&index=0&id=73d70664&scoped=true&lang=css"

import exportComponent from "/Users/francesco/opt/ABIT/resources/js/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73d70664"]])

export default __exports__